import React from 'react';

const FormsIcon = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.667 8.83333H1.50033C1.04199 8.83333 0.666992 9.20833 0.666992 9.66667V14.6667C0.666992 15.125 1.04199 15.5 1.50033 15.5H15.667C16.1253 15.5 16.5003 15.125 16.5003 14.6667V9.66667C16.5003 9.20833 16.1253 8.83333 15.667 8.83333ZM15.667 0.5H1.50033C1.04199 0.5 0.666992 0.875 0.666992 1.33333V6.33333C0.666992 6.79167 1.04199 7.16667 1.50033 7.16667H15.667C16.1253 7.16667 16.5003 6.79167 16.5003 6.33333V1.33333C16.5003 0.875 16.1253 0.5 15.667 0.5Z" fill="currentColor"/>
    </svg>
  )
}

export default FormsIcon;